<template>
  <div class="content">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step title="身分確認"></el-step>
      <el-step title="パスワード変更"></el-step>
      <el-step title="変更完了"></el-step>
    </el-steps>
    <!-- 手机验证修改密码 -->
    <div class="shouji" v-if="active != 3">
      <h2>パスワード確認中</h2>
      <div class="changbox">
        <div class="form">
          <el-form
            :model="editForm"
            :rules="passRules"
            ref="passRef"
            v-if="!show"
          >
            <ol>
              <li class="yzm">
                <el-form-item
                  prop="Validation"
                  label="現在のパスワード"
                  label-width="150px"
                >
                  <el-input
                    v-model="editForm.Validation"
                    class="ipt"
                    type="password"
                  ></el-input>
                </el-form-item>
              </li>
              <li class="btn">
                <button @click="login">次へ</button>
              </li>
            </ol>
          </el-form>
          <el-form :model="editForm" :rules="formRules" ref="formRef" v-else>
            <ol>
              <li>
                <el-form-item
                  prop="newPwd"
                  label="新規パスワード"
                  label-width="150px"
                >
                  <el-input
                    v-model="editForm.newPwd"
                    class="ipt"
                    type="password"
                  ></el-input>
                </el-form-item>
              </li>
              <li>
                <el-form-item
                  prop="affirmPwd"
                  label="パスワード再確認"
                  label-width="150px"
                >
                  <el-input
                    v-model="editForm.affirmPwd"
                    class="ipt"
                    type="password"
                  ></el-input>
                </el-form-item>
              </li>
              <li class="btn">
                <button @click="modification">次へ</button>
                <button @click="$parent.index = 0">その他の認証方法</button>
              </li>
            </ol>
          </el-form>
        </div>
      </div>
    </div>
    <div v-else class="success">
      修正完了、ログインされました。
      <router-link to="/login"> ログインされました。</router-link>
      <router-link to="/register">新規ログインしてください。</router-link>
    </div>
  </div>
</template>
<script>
import { getNewPwd } from "../../api/API/user";
import { sendSMS, login } from "../../api/API/login";
export default {
  data() {
    var userPassWord = (rule, value, callback) => {
      if (this.editForm.affirmPwd === "") {
        callback(new Error("確認コードをご記入ください"));
      } else if (this.editForm.newPwd === this.editForm.affirmPwd) {
        callback();
      } else {
        callback(
          new Error(`上記設定のパスワードと同じになるようご記入ください
`)
        );
      }
    };
    return {
      token: localStorage.getItem("token"),
      active: 0,
      index: 0, // 索引
      show: true,
      num: "", // 随机生成6位数
      Countdown: 60, // 倒计时
      // 修改密码
      editForm: {
        Validation: "",
        newPwd: "",
        affirmPwd: "",
      },
      show: false,
      passRules: {
        Validation: [
          {
            required: true,
            message: "確認コードをご記入ください",
            trigger: "blur",
          },
        ],
      },

      formRules: {
        newPwd: [
          {
            required: true,
            pattern: /^(\w){6,20}$/,
            message: "パスワードは6桁以上16桁以内に収めてください",
          },
        ],
        affirmPwd: [
          {
            required: true,
            validator: userPassWord,
          },
        ],
      },
    };
  },
  methods: {
    // 发送验证码
    sendValidation() {
      for (var i = 0; i < 6; i++) {
        this.num += Math.floor(Math.random() * 10);
      }

      var list = {
        code: this.num,
        phone: this.$store.state.userInfo.data.mobile,
        type: 2,
        ptype: 81,
      };

      console.log(list);
      sendSMS(this.num).then((res) => {
        this.active = 1;
        let datas = JSON.parse(res.substr(12, res.length - 14));
        console.log(datas);
        if (datas.code == -1) return this.$message.error(datas.msg);
        this.show = false;
        var timer = setInterval(() => {
          this.Countdown -= 1;
          if (this.Countdown <= 0) {
            this.show = true;
            this.Countdown = 60;
            clearInterval(timer);
          }
        }, 1000);
      });
      console.log(this.num);
    },
    //旧密码验证
    login() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "login",
        username: this.$store.state.userInfo.data.ddusername,
        password: this.editForm.Validation,
      };
      this.$refs.passRef.validate((valid) => {
        if (valid) {
          login(list).then((res) => {
            console.log(res);
            if (res.code != 1) return this.$message.error("更新失敗しました");

            this.show = true;
            this.active = 2;
          });
        }
      });
    },
    // 修改密码
    modification() {
      //   if (
      //     this.num != this.editForm.Validation &&
      //     this.editForm.Validation != "888888"
      //   ) {
      //     return this.$message.error("確認コードをご記入ください");
      //   }
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "getNewPwd",
        token: this.token,
        password: this.editForm.newPwd,
      };
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          getNewPwd(list).then((res) => {
            if (res.code != 1) return this.$message.error(res.msg);
            this.active = 3;
            this.index = 0;
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 80px 120px;
  border: 1px solid #ccc;
  h2 {
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 50px;
  }
  ul {
    li {
      height: 100px;
      border: 1px solid #ccc;
      padding: 30px 40px 0;
      margin-bottom: 50px;
      img {
        width: 58px;
        vertical-align: middle;
      }
      span {
        font-size: 18px;
        //   line-height: 58px;
        margin-left: 15px;
        font-weight: 700;
      }
      button {
        float: right;
        width: 120px;
        height: 40px;
        background: #f3c622;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
        border-radius: 5px;
        margin-top: 15px;
        cursor: pointer;
      }
    }
  }
  .changbox {
    padding: 50px 80px;
    border: 1px solid #ccc;
    h3 {
      font-size: 20px;
      // border-bottom: 1PX solid #ccc;
    }
    ol {
      width: 800px;
      margin-left: 180px;
      li {
        height: 60px;
        line-height: 60px;
        span {
          display: inline-block;
          width: 150px;
          font-size: 16px;
        }
        .ipt {
          width: 200px;
          height: 30px;
        }

        button {
          background-color: #f3c622;
          color: #fff;
          height: 32px;
          cursor: pointer;
        }
      }
      .btn {
        button {
          margin-left: 200px;
          border-radius: 5px;
          width: 100px;
        }
      }
      .yzm {
        height: 65px;
        p {
          line-height: 30px;
          width: 350px;
          text-align: right;
          margin-top: -20px;
          color: #f3c622;
          cursor: pointer;
          font-size: 12px;
        }
      }
    }
  }
  .success {
    font-size: 20px;
    text-align: center;
    width: 500px;
    margin: 20px auto;
    padding: 40px;
    border: 1px solid #ccc;
    a {
      text-decoration: underline;
      color: #f3c622;
    }
  }
}
</style>